// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"0a1953a9","377":"f83782c5","672":"898996e6","688":"b72411ca","707":"aa02a027","858":"a561ac10"}[chunkId] + ".chunk.css";
};